module.exports = __webpack_public_path__ + "img/Needle.0f570460.png";